module.exports = __webpack_public_path__ + "img/ecolab_logo.d16e97cb.svg";